import { Form } from 'factorial-form'
import { CustomFieldItemFragment } from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'

const valueType = (customFieldType: string) => {
  switch (customFieldType) {
    case FieldTypes.text:
    case FieldTypes.longText:
    case FieldTypes.singleChoice:
    case FieldTypes.multipleChoice:
      return 'string'
    case FieldTypes.cents:
    case FieldTypes.money:
      return 'cents'
    case FieldTypes.date:
      return 'date'
    case FieldTypes.checkbox:
      return 'boolean'
    case FieldTypes.rating:
      return 'number'
    default:
      return null
  }
}

const fillChoiceOptions = (cf: CustomFieldItemFragment) => {
  if (!cf.options) {
    return []
  }

  return cf.options.map((option) => {
    return {
      id: option.id,
      is_active: option.isActive,
      label: option.label,
      value: option.value,
    }
  })
}

const defaultValue = (cf: CustomFieldItemFragment) => {
  switch (cf.fieldType) {
    case FieldTypes.rating:
      return cf.minValue
    case FieldTypes.date:
    case FieldTypes.cents:
      return null
    default:
      return ''
  }
}

const createCustomFieldForm = (customField: CustomFieldItemFragment) => {
  const values = {
    choice_options: fillChoiceOptions(customField),
    editable: true,
    field_id: customField.id,
    field_type: customField.fieldType,
    mandatory: customField.required,
    max_value: customField.maxValue,
    min_value: customField.minValue,
    name: customField.labelText,
    options: customField.options,
    resource_id: customField.resourceFields[0]?.id.toString(),
    withNullLabel:
      customField.fieldType === FieldTypes.date ? i18n.t('settings.custom_fields.remove_date') : '',
    value: defaultValue(customField),
  }

  return new Form(values, {
    choice_options: 'string',
    editable: 'boolean',
    field_id: 'string',
    field_type: 'string',
    mandatory: 'boolean',
    max_value: 'number',
    min_value: 'number',
    name: 'string',
    options: 'string',
    resource_id: 'string',
    withNullLabel: 'string',
    value: valueType(customField.fieldType),
  })
}

export const buildCustomFieldForms = (customFields: CustomFieldItemFragment[]): Form[] => {
  // README: when customField.resourceFields is empty it means
  // the user has no permissions to edit the custom field. Only to see it.
  return sortBy(customFields, (cf) => cf.position)
    .filter((customField) => customField.resourceFields.length > 0)
    .map((customField) => createCustomFieldForm(customField))
}
